<template>
  <div class="absolute fill-height events-page">
    <v-snackbar v-model="ok_snackbar" :timeout="3000" color="green darken-3 white--text" :top="true">
      {{ ok_text }}
      <v-btn color="white" flat @click="ok_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="error_snackbar" :timeout="3000" color="red darken-3 white--text" :top="true">
      {{ error_text }}
      <v-btn color="white" flat @click="error_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Počáteční kredity spolupracovníků</h3>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>
                    <router-link :to="{ path: '/spolupracovnici/' + props.item.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    <v-text-field
                      type="number"
                      :rules="rules"
                      v-model="props.item.pocatecni_kredity"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      type="number"
                      :rules="rules"
                      v-model="props.item.pocatecni_kredity_skupinove"
                    ></v-text-field>
                  </td>
                </template>
              </v-data-table>
            </div>
            <v-layout row wrap class="mt-5 mb-5 text-xs-center">
              <v-flex xs12>
                <v-btn color="primary" @click="save" class="ma-0" depressed :loading="saving" large>Uložit kariérní pozice</v-btn>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      updateItem: {},
      headers: [
        { text: 'ID', value: 'id', width: '30px' },
        { text: 'Osoba', value: 'osoba.nazev_osoby' },
        { text: 'Vlastní počáteční kredity', value: 'pocatecni_kredity', width: 200 },
        { text: 'Skupinové počáteční kredity', value: 'pocatecni_kredity_skupinove', width: 200 },
      ],
      loadingTable: true,
      search: "",
      items: [],
      dialog: false,
      saving: false,
      rules: [
        (e) => e == null || e.length == 0 || !isNaN(e) || "Musí být číslo"
      ]
    }
  },
  computed: {
    th () {
      return window.th;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {

  },
  methods: {
    load: function(f) {
      this.loadingTable = true;
      window.API.get("osoby/pocatecni-kredity/seznam").then(function(body) {
        this.items.replace(body);
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    save () {
      this.saving = true;
      window.API.post("osoby/pocatecni-kredity/seznam", {
        pocatecni_kredity: this.items.map((e) => {
          return {
            id: e.id,
            pocatecni_kredity: e.pocatecni_kredity,
            pocatecni_kredity_skupinove: e.pocatecni_kredity_skupinove
          };
        })
      }).then(function(body) {
        if (body.status) {
          this.load(() => {
            this.saving = false;
            this.ok("Kredity byly uloženy");
          });
        }
        else {
          this.saving = false;
          this.error("Kredity nebyly uloženy");
        }
      }.bind(this)).catch(function(err) {
        this.saving = false;
        this.error("Kredity nebyly uloženy");
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TestTools/NastaveniPocatecnichKreditu.vue